export default {
  en: {
    editRoomType: 'Edit Room Type',
    roomTypeList: 'Room Type',
    code: 'Code',
    name: 'Name',
    status: 'Status',
    edit: 'Save Changes',
    cancel: 'Cancel',
    editRoomTypeSuccessTitle: 'Success',
    editRoomTypeSuccessMessage: 'Update Room Type Success.'
  },
  th: {
    newRoomType: 'แก้ไขประเภอห้อง',
    roomTypeList: 'รายการประเภทห้อง',
    code: 'โค้ด',
    name: 'ชื่อ',
    status: 'สถานะ',
    edit: 'บันทึก',
    cancel: 'ยกเลิก',
    editRoomTypeSuccessTitle: 'สำเร็จ',
    editRoomTypeSuccessMessage: 'แก้ไขประเภทห้องสำเร็จ'
  }
}
